import { compact } from "lodash";
import { useState } from "react";
import { GetDeliveredEngagementSurveyQuery } from "types/graphql-schema";

import Layout from "@components/layout/layout";
import usePkParams from "@helpers/hooks/use-pk-params";

import EngagementSurveyDelivery from "./engagement-survey-delivery";

const EngagementSurveyDeliveryPage = () => {
  const assessmentDeliveryId = usePkParams("assessmentDeliveryId");
  const [deliveryData, setDeliveryData] =
    useState<GetDeliveredEngagementSurveyQuery["assessmentDelivery"]>(null);

  return (
    <Layout className="bg-white">
      <Layout.Header
        breadcrumbs={compact([
          {
            title: "Surveys",
            url: "/survey",
          },
          deliveryData && {
            title: `Survey: ${
              deliveryData.complianceProgram?.title || "Untitled"
            }`,
            url: `/survey/delivery/${assessmentDeliveryId}`,
          },
        ])}
        className="bg-white"
      />
      <EngagementSurveyDelivery
        assessmentDeliveryId={assessmentDeliveryId}
        onUpdateDeliveryData={setDeliveryData}
      />
    </Layout>
  );
};

export default EngagementSurveyDeliveryPage;
